import { createFileRoute, Link, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/$")({
  beforeLoad: () => {
    // A rendered 404 page is not enough for legacy URLs: throw the router's
    // not-found signal so SSR emits HTTP 404 as well as the noindex UI below.
    throw notFound();
  },
  head: () => ({
    meta: [{ name: "robots", content: "noindex, nofollow" }],
  }),
  component: NotFoundPage,
  notFoundComponent: NotFoundPage,
});

function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center justify-center px-4 py-24 text-center animate-fade-up">
      <p className="text-6xl font-bold text-[var(--border)]">404</p>
      <h1 className="mt-4 text-xl font-semibold">Page not found</h1>
      <p className="mt-2 text-sm text-[var(--text-muted)]">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-lg bg-[var(--text)] px-4 py-2 text-sm font-medium text-[var(--text-inverse)] hover:opacity-90"
      >
        Back to Home
      </Link>
    </div>
  );
}
